import { render, staticRenderFns } from "./OwnerFormGroup.vue?vue&type=template&id=7ff11fa4&"
import script from "./OwnerFormGroup.vue?vue&type=script&lang=ts&"
export * from "./OwnerFormGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports